import { render, staticRenderFns } from "./CameraDeviceSelector.vue?vue&type=template&id=23ffb193"
import script from "./CameraDeviceSelector.vue?vue&type=script&lang=js"
export * from "./CameraDeviceSelector.vue?vue&type=script&lang=js"
import style0 from "./CameraDeviceSelector.vue?vue&type=style&index=0&id=23ffb193&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ffb193')) {
      api.createRecord('23ffb193', component.options)
    } else {
      api.reload('23ffb193', component.options)
    }
    module.hot.accept("./CameraDeviceSelector.vue?vue&type=template&id=23ffb193", function () {
      api.rerender('23ffb193', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Device/CameraDeviceSelector.vue"
export default component.exports